/* Gorilla Vapes — "Choose your free shot" selector on qualifying Shortfill PDPs.
   The gift discount frees the dearest qualifying shot(s) in the cart, so this
   lets the customer pick their shot(s) and adds them via the Cart AJAX API.

   The selector sits OUTSIDE the product form. To avoid the "I picked shots but
   they didn't land" trap, BOTH add paths add everything together:
     • the selector's own "Add to basket + N free shots" button, and
     • the product's MAIN "Add to Cart" (intercepted when shots are chosen)
   each add the product (its selected variant + quantity) PLUS the chosen shots
   in one /cart/add.js, then show the cart.

   data-get = how many free shots the offer grants (50ml = 1, 100ml = 2). The
   shots are real line items, so a customer can add more than the free
   allocation — extras beyond `get` are simply charged by the discount engine. */
(function () {
  'use strict';

  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }

  function setup(box) {
    if (box.dataset.gvReady) return;
    box.dataset.gvReady = '1';
    var get = Math.max(1, parseInt(box.getAttribute('data-get'), 10) || 1);
    var opts = Array.prototype.slice.call(box.querySelectorAll('.gv-gift__opt'));
    var addBtn = box.querySelector('[data-gv-gift-add]');
    var statusEl = box.querySelector('[data-gv-gift-status]');
    var sel = {};       // variant id -> chosen quantity
    var busy = false;

    // The product's MAIN add-to-cart form (the selector is rendered outside it).
    var form = document.querySelector('product-form form[action*="/cart/add"]') ||
               document.querySelector('form[action*="/cart/add"]');

    function total() { var t = 0; for (var k in sel) t += sel[k]; return t; }
    function chosenShots() { var a = []; for (var v in sel) a.push({ id: Number(v), quantity: sel[v] }); return a; }

    function refresh() {
      var t = total();
      opts.forEach(function (o) {
        var v = o.getAttribute('data-variant');
        var q = sel[v] || 0;
        o.classList.toggle('is-selected', q > 0);
        var badge = o.querySelector('.gv-gift__opt-qty');
        if (q > 0) {
          if (!badge) { badge = document.createElement('span'); badge.className = 'gv-gift__opt-qty'; o.appendChild(badge); }
          badge.textContent = q > 1 ? ('×' + q) : '✓';
        } else if (badge) { badge.remove(); }
      });
      addBtn.disabled = t !== get;
      if (t >= get) addBtn.textContent = 'Add to basket + ' + get + ' free shot' + (get > 1 ? 's' : '');
      else addBtn.textContent = 'Choose ' + (get - t) + ' more free shot' + ((get - t) > 1 ? 's' : '');
      if (statusEl) statusEl.textContent = get > 1 ? (t + ' of ' + get + ' chosen') : '';
    }

    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        var v = o.getAttribute('data-variant');
        if (!v) return;
        var t = total();
        if ((sel[v] || 0) > 0 && t >= get) { sel[v]--; if (sel[v] <= 0) delete sel[v]; }
        else if (t < get) { sel[v] = (sel[v] || 0) + 1; }
        else if (get === 1) { sel = {}; sel[v] = 1; }
        refresh();
      });
    });

    // Add the product (its selected variant + quantity from the form) together
    // with the chosen free shots, then show the cart. `fromForm` = triggered by
    // the main Add-to-Cart, so on failure we fall back to a plain product add.
    function addAll(fromForm) {
      if (busy) return;
      var shots = chosenShots();
      if (!shots.length) return;
      busy = true;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      var items = [];
      if (form) {
        var idEl = form.querySelector('[name="id"]');
        var qtyEl = form.querySelector('[name="quantity"]');
        var vid = idEl && idEl.value ? Number(idEl.value) : null;
        var qty = qtyEl && qtyEl.value ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
        if (vid) items.push({ id: vid, quantity: qty });
      }
      items = items.concat(shots);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { done(box); showCart(); })
        .catch(function () {
          if (fromForm && form) { form.submit(); return; }   // graceful fallback: plain add
          busy = false;
          addBtn.disabled = false;
          addBtn.textContent = 'Try again';
          if (statusEl) statusEl.textContent = 'Could not add — please try again.';
        });
    }

    // 1) The selector's own button.
    addBtn.addEventListener('click', function () { if (total() === get) addAll(false); });

    // 2) The product's MAIN "Add to Cart": if free shots are chosen, take over
    //    so they ride along (otherwise the theme adds only the shortfill).
    //    Capture phase + stopImmediatePropagation pre-empts the theme's own
    //    bubble-phase submit handler.
    if (form) {
      form.addEventListener('submit', function (e) {
        if (total() > 0 && !busy) {
          e.preventDefault();
          e.stopImmediatePropagation();
          addAll(true);
        }
      }, true);
    }

    refresh();
  }

  function done(box) {
    box.innerHTML =
      '<p class="gv-offer__gift gv-gift--done"><strong>✓ Added to your basket</strong> — ' +
      'opening your basket so you can see your free nic shots… ' +
      '<a class="gv-gift__viewcart" href="' + cartUrl() + '">View basket →</a></p>';
  }

  // Show the customer the result. If the theme uses a slide-out drawer, refresh
  // + open it; otherwise (this store uses a cart PAGE) go to /cart so the
  // shortfill + free shots are clearly visible and editable.
  function showCart() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); })
        .then(function (sections) { drawer.renderContents({ sections: sections }); })
        .catch(function () { window.location.href = cartUrl(); });
      return;
    }
    window.location.href = cartUrl();
  }

  function init() {
    var boxes = document.querySelectorAll('[data-gv-gift]');
    for (var i = 0; i < boxes.length; i++) setup(boxes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
